import {Progress} from "antd";
import {PoolDensityWrapper} from "./PoolDensity.styles";
import React, {useState} from "react";
import {ClickableSpan} from "../pools/poolIntensities/responsiveDataTable/ResponsiveDataTable.styles";

const conicColors = {
    "0%": "red",
    "50%": "#ffe58f",
    "100%": "#AEFF01"
};

export const PoolDensity = ({poolShiftDetails, isMobile}) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        if (isMobile) {
            setExpanded(prevExpanded => !prevExpanded);
        }
    };

    return (
        <>
            <PoolDensityWrapper>
                {expanded && (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                transform: "scale(0.7)",
                                gap: "25px",
                                padding: "0",
                                flexDirection: isMobile ? "column" : "row"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column"
                                }}
                            >
                                <h4 style={{textAlign: "center"}}>Saatlik Havuz Yoğunluğu</h4>
                                <Progress
                                    type="dashboard"
                                    strokeWidth={12}
                                    percent={poolShiftDetails?.courierRates?.byCurrentHour}
                                    strokeColor={conicColors}
                                    format={percent => `${percent}%`}
                                />
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <h4 style={{textAlign: "center"}}>Günlük Havuz Yoğunluğu</h4>
                                <Progress
                                    type="dashboard"
                                    strokeWidth={12}
                                    percent={poolShiftDetails?.courierRates?.byCurrentDay}
                                    strokeColor={conicColors}
                                    format={percent => `${percent}%`}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <div
                    style={{
                        transform: "scale(0.85)",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        cursor: isMobile ? "pointer" : "default"
                    }}
                    onClick={toggleExpanded}
                >
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <ClickableSpan style={{fontSize: "16px"}}>
                            Anlık Havuz Yoğunluğu
                        </ClickableSpan>
                        <Progress
                            type="dashboard"
                            strokeWidth={12}
                            percent={poolShiftDetails?.courierRates?.byNow}
                            format={percent => `${percent}%`}
                            status="exception"
                            strokeColor={conicColors}
                            onMouseEnter={() => !isMobile && setExpanded(true)}
                            onMouseLeave={() => !isMobile && setExpanded(false)}
                        />
                    </div>
                </div>
            </PoolDensityWrapper>
        </>
    );
};
